import { BaseIcon } from './base';
import type { IconSmallProps } from './base';

export function IconRatingSmall(props: IconSmallProps) {
  return (
    <BaseIcon {...props} size={16} viewBox="0 0 16 16">
      <path
        d="M9 3C9 2.44772 8.55228 2 8 2C7.44772 2 7 2.44772 7 3V5H5C4.44772 5 4 5.44772 4 6C4 6.55228 4.44772 7 5 7H7V9C7 9.55228 7.44772 10 8 10C8.55228 10 9 9.55228 9 9V7H11C11.5523 7 12 6.55228 12 6C12 5.44772 11.5523 5 11 5H9V3ZM4 13C4 12.4477 4.44772 12 5 12H11C11.5523 12 12 12.4477 12 13C12 13.5523 11.5523 14 11 14H5C4.44772 14 4 13.5523 4 13Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
